import { render } from "./Privacy.vue?vue&type=template&id=dade09e2"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"
script.render = render

export default script